import * as React from "react";
import DraggableListItem from "./draggableListItem";
import {
  DragDropContext,
  Droppable,
  OnDragEndResponder,
} from "react-beautiful-dnd";

const DraggableList = React.memo(
  ({
    items,
    onDragEnd,
    onDelete,
    onDuplicate,
    onEdit,
    onClick,
    selectedId,
    textColor = "black",
  }) => {
    if (!items) {
      return <div>Items: {items}</div>;
    }

    return (
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable-list">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {items.map((item, index) => (
                <DraggableListItem
                  key={item.id}
                  item={item}
                  index={index}
                  onDelete={onDelete}
                  onDuplicate={onDuplicate}
                  onEdit={onEdit}
                  onClick={onClick}
                  selectedId={selectedId}
                  textColor={textColor}
                />
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
);

export default DraggableList;
